import { DepartmentModel } from "@app/catalog";

export class DepartmentAddedMessage {
    public department: DepartmentModel;
    
    constructor(department: DepartmentModel)
    {
        this.department = department;
    }
}